module.exports = __webpack_public_path__ + "img/5.c78f512b.jpg";